import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { IFullNameEntity, IFullNameSettings } from "@webapp/ui/gh-full-name/gh-full-name.models";

@Component({
  selector: "gh-full-name",
  templateUrl: "./gh-full-name.component.html",
  styleUrls: ["./gh-full-name.component.less"],

  host: {
    "[class.gh-name-ellipsis]": `ghFullNameSettings.nameEllipsis === true`,
  },
})
export class GhFullNameComponent implements OnInit, OnChanges {
  @Input()
  public ghFullNameSettings?: IFullNameSettings;

  @Input()
  public ghFullNameSearchTerm?: string = "";

  @Input()
  public ghFullNameEntity: IFullNameEntity;

  public isDeleted?: boolean;

  public isDeactivated?: boolean;

  get fullName(): string {
    return this.fullNameParsed;
  }
  private fullNameParsed = "";

  private defaultSettings: IFullNameSettings = {
    multiline: false,
    center: true,
    maxLength: Infinity,
  };

  public ngOnInit(): void {
    this.ghFullNameSettings = { ...this.defaultSettings, ...this.ghFullNameSettings };
    this.initData();
  }

  private initData(): void {
    if (!this.ghFullNameEntity || this.ghFullNameEntity.isDeleted) {
      this.isDeleted = true;
      return;
    }

    this.fullNameParsed = this.getFullName();
    this.isDeleted = !this.fullNameParsed && !this.ghFullNameEntity.id;
    this.isDeactivated = this.ghFullNameEntity.isActive === false;
  }

  private getFullName(): string {
    if (!this.ghFullNameEntity) {
      return "";
    }
    let name = this.ghFullNameEntity.names || this.ghFullNameEntity.name || "";
    if (this.ghFullNameEntity.firstName !== undefined && this.ghFullNameEntity.lastName !== undefined) {
      name = `${this.ghFullNameEntity.firstName} ${this.ghFullNameEntity.lastName}`.trim();
    }
    if (this.ghFullNameSettings.wordsNumber) {
      name = name.split(" ", this.ghFullNameSettings.wordsNumber).join(" ");
    }
    if (name.length > this.ghFullNameSettings.maxLength) {
      return `${name.slice(0, this.ghFullNameSettings.maxLength)}...`;
    }
    return name;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.ghFullNameEntity.isFirstChange()) {
      return;
    }
    this.ghFullNameEntity = changes.ghFullNameEntity.currentValue;
    if (changes.ghFullNameSettings && changes.ghFullNameSettings.currentValue) {
      this.ghFullNameSettings = { ...this.defaultSettings, ...changes.ghFullNameSettings.currentValue };
    }
    this.initData();
  }
}
